export default {
  titleContent: {
    type: String,
    default: 'incluido'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/components/resources/props.js